// used only to get the theming data for the scavenger hunts
// aka the types of themes
// and the characters

import {createSlice} from '@reduxjs/toolkit';
import {defaultThemes} from 'src/Data/DefaultThemes';

// console.log({defaultThemes});

const themesSlice = createSlice({
  name: 'themeInfo',
  initialState: defaultThemes,
  reducers: {
    setThemes(state, {payload = {}}) {
      console.log('SET_THEMES: new themes set');
      // console.log({newThemes: payload.themes});
      return {
        themes: !!payload.themes
          ? {...state.themes, ...payload.themes}
          : state.themes,
        themesList:
          payload.themes_list?.length > 0
            ? [...payload.themes_list]
            : state.themesList,
        characters: !!payload.characters
          ? {...state.characters, ...payload.characters}
          : state.characters,
      };
    },
  },
});

export const {setThemes} = themesSlice.actions;
export default themesSlice.reducer;
